module.exports = __webpack_public_path__ + "static/img/dialog2.7c6c054.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/activity4/dialog2.png
// module id = zEj6
// module chunks = 7